import { State } from 'app/redux';

export const getSettingsPicking = (state: State) => state.settings.picking;
